// extracted by mini-css-extract-plugin
module.exports = {"container":"FantasyBanner_container__z2I34","fancy":"FantasyBanner_fancy__35pdz","button":"FantasyBanner_button__3Qc1m"};